import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getAudienceAdminList } from '~/services/PromoService';

import { audienceAdminQueryKeys } from './audienceAdminQueryKeys';

type Params = {
  query: Parameters<typeof getAudienceAdminList>[0];
  enabled?: boolean;
};

export function useGetAudienceAdminList({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: audienceAdminQueryKeys.list(query),
    queryFn: async ({ signal }) => getAudienceAdminList(query, { signal }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
